<template>

    <div class="min-h-screen flex flex-col">

        <navbar></navbar>

        <div class="flex-1 mb-10">

            <!-- Header -->
            <section class="p-20 topo-bkg" :style="{'background-image': 'url(' + require('@/assets/images/stormy-bkg.jpg') + ')'}" style="background-size: cover; background-position: center center; padding-top:10em; padding-bottom: 10em;">

                <div class="md:px-0 container mx-auto px-5">
                    <h1 class="text-white uppercase text-5xl">Live Storm Chasing: The Storm Awaits</h1>
                    <div class="text-white pt-3 flex flex-col lg:flex-row content-center">
                        <div class="pb-2 lg:pb-0">
                            <i class="fa fa-calendar lg:mr-1"></i> May 9, 2019
                        </div>
                        <div class="lg:ml-4 pb-2 lg:pb-0">
                            <i class="fa fa-user lg:mr-1"></i> Tyler Youschak
                        </div>
                        <div class="lg:ml-4 pb-2 lg:pb-0">
                            <i class="fa fa-clock lg:mr-1"></i> 6 min read
                        </div>
                        <div class="lg:ml-4 pb-2 lg:pb-0">
                            <i class="fa fa-tag lg:mr-1"></i> <span class="rounded bg-grey-darker uppercase px-2 py-1 text-xs font-bold mr-3">updates</span>
                        </div>

                    </div>
                </div>

            </section>

            <!-- Features -->
            <section class="px-5 md:px-0 container mx-auto mt-10">

                <div class="w-full lg:flex mb-10 h-64">
                    <div class="lg:h-auto lg:w-1/4 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden" :style="{'background-image': 'url(' + require('@/assets/images/features/lsr.png') + ')'}" style="background-position: center center;" title="Chaser Locations">
                    </div>
                    <div class="lg:h-auto lg:w-1/4 flex-none bg-cover rounded-t lg:rounded-t-none text-center overflow-hidden" :style="{'background-image': 'url(' + require('@/assets/images/features/lightning.png') + ')'}" style="background-position: center center;" title="Chaser Locations">
                    </div>
                    <div class="lg:h-auto lg:w-1/4 flex-none bg-cover rounded-t lg:rounded-t-none text-center overflow-hidden" :style="{'background-image': 'url(' + require('@/assets/images/features/radar.jpg') + ')'}" style="background-position: center center;" title="Chaser Locations">
                    </div>
                    <div class="lg:h-auto lg:w-1/4 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-r text-center overflow-hidden" :style="{'background-image': 'url(' + require('@/assets/images/features/tropical-storm-tracks.png') + ')'}" style="background-position: center center;" title="Chaser Locations">
                    </div>
                </div>

                <div class="w-full mb-5">
                    <p class="text-white text-base justify-between leading-normal text-lg">
                        <strong>After nearly 2 years since launch,</strong> I figured it was time to turn Live Storm Chasing into how I originally envisioned the platform. So far, the platform has been a wonderful proof-of-concept; but now it's time to add the bells and whistles that have been requested and to fix some bugs that were experienced. Over the past 6-8 months, I have been focusing on redeveloping this platform from the ground up and it is finally ready for public access! Please read below to see all of the new fantastic additions that I have added to make everyone's experience much better. The only thing we need now is a storm; <em>the storm awaits</em>!
                    </p>
                </div>

                 <div class="w-full mb-5">
                    <h2 class="text-white">Bells and whistles, you say?</h2>
                    <p class="text-white text-base justify-between leading-normal text-lg">
                        <ul>
                            <li class="py-1"><strong>Radar Features:</strong> Faster load time with the radar layer! You now also have the ability to load raw or smoothed data.</li>
                            <li class="py-1"><strong>Watches and Warnings:</strong> You are now able to view multiple types of watches and warnings. You are no longer restricted to just severe alerts!</li>
                            <li class="py-1"><strong>Storm Reports:</strong> You are now able to view local storm reports (LSRs) around the country. View hail reports, snow reports, flooding reports, tornado reports and more! Check it out yourself!</li>
                            <li class="py-1"><strong>Stream Chat:</strong> We are now using an in-house chat system. You are now able to pull it up along site the stream you are watching.</li>
                            <li class="py-1"><strong>Settings:</strong> You can now change settings to your liking. Some new features include dark mode, changeable map themes, and alert preferences.</li>
                            <li class="py-1"><strong>User Accounts:</strong> Probably one of the best features that we now have is user accounts. You can now set your settings to your desire and save them for the next time you visit our site!</li>
                            <li class="py-1"><strong>Lightning:</strong> Are you a lightning lover? If so, you will enjoy our latest experimental feature: lightning data! View lightning strikes with up-to-the-minute data as you watch chaser streams. Each yellow lightning bolt represents a strike.</li>
                        </ul>
                    </p>
                </div>

                <div class="w-full mb-5">
                    <h2 class="text-white">So what else?</h2>
                    <p class="text-white text-base justify-between leading-normal text-lg">
                        There are many other new features you may notice; however, we only chose to feature a few in this post. We also have many more to add as time goes on. Monitor this blog page and our Facebook page to learn about upcoming features. Thank you for your excitement with this new update. We hope you enjoy it as much as we do!
                    </p>
                </div>

                <div class="w-full mb-5">
                    <h2 class="text-white">Suggestions?</h2>
                    <p class="text-white text-base justify-between leading-normal text-lg">
                        We love feed back and will use it to make your experience even better! Let us know in the <strong>Further Discussion</strong> section below.
                    </p>
                </div>

                <!-- <div class="w-full mt-20 mb-15">
                    <div class="bg-white rounded flex flex-col">
                        <div class="mx-auto py-10 text-center">
                            <img src="https://pbs.twimg.com/profile_images/562405484603252736/fufMkDgz_400x400.jpeg" class="rounded-full w-24 h-24" />
                            <h3 class="pt-2">Tyler Youschak</h3>
                        </div>
                    </div>
                </div> -->

            </section>

            <section class="bg-white">
                <div class="px-5 pb-5 md:px-0 container mx-auto mt-10 -mb-10">
                    <h1 class="font-2xl py-5">Further Discussion...</h1>
                    <vue-disqus shortname="live-storm-chasing" identifier="relaunch-the-storm-awaits" url="https://livestormchasing.com/blog/relaunch-the-storm-awaits"></vue-disqus>
                </div>
            </section>


        </div>

        <page-footer></page-footer>

    </div>
</template>

<script>

    import * as Config from '../config'

    import Navbar from '@/components/Navbar'
    import PageFooter from '@/components/PageFooter'
    import Gravatar from 'vue-gravatar';

    export default {
        name: 'home',
        components: {
            PageFooter,
            Gravatar,
            Navbar
        },
        data() {
            return {
                open: false,
            }
        },
        methods: {
            toggle() {
                this.open = !this.open
            },
        },
    }

</script>

<style>
    .navbar-logo {
        max-height: 40px;
        width: auto;
    }
    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }
    .embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
